import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../lib/seo';

const Contact = () => {
  useEffect(() => {
    setPageMeta({
      title: 'Contact | Clouniq',
      description: 'Get in touch with clouniq for billing, access, and technical support.',
    });
  }, []);

  return (
    <section className="contact-page contact-rebuild">
      <div className="container">
        <div className="contact-hero nova-contact-hero">
          <span className="section-tag">Contact</span>
          <h1 className="section-title">Contact CLOUNIQ</h1>
          <p className="section-subtitle">
            Reach out for account access, billing, infrastructure questions, or technical support.
          </p>
        </div>

        <div className="contact-grid nova-contact-grid contact-rebuild-grid">
          <div className="contact-card glass nova-contact-card contact-rebuild-card">
            <h2 className="contact-card-title">Support channels</h2>
            <p className="contact-card-text">
              Typical response time is under 24 hours on business days.
            </p>
            <a className="contact-link" href="mailto:info@clouniq.com">
              info@clouniq.com
            </a>
            <div className="contact-rebuild-links">
              <Link to="/docs" className="contact-rebuild-pill">Documentation</Link>
              <Link to="/dashboard" className="contact-rebuild-pill">Workspace</Link>
              <Link to="/privacy" className="contact-rebuild-pill">Policies</Link>
            </div>
          </div>

          <div className="contact-card glass nova-contact-card contact-rebuild-card">
            <h2 className="contact-card-title">Company details</h2>
            <div className="contact-legal">
              <div className="contact-legal-row">
                <span className="contact-legal-key">Company</span>
                <span className="contact-legal-value">-</span>
              </div>
              <div className="contact-legal-row">
                <span className="contact-legal-key">Company number</span>
                <span className="contact-legal-value">-</span>
              </div>
              <div className="contact-legal-row">
                <span className="contact-legal-key">Registered address</span>
                <span className="contact-legal-value">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;




